interface IsLaunchDarklyInitTimeoutErrorParams {
  message: string
}

/**
 * The LaunchDarkly SDK logs this through its `error` channel — which the repo's filtered logger
 * forwards to `console.error`, and RUM captures as a `source:console` error — whenever the bounded
 * `waitForInitialization` wait expires before the flag fetch resolves. Non-actionable on a
 * backgrounded tab, where the browser throttles the in-flight fetch into a stall the bound is
 * there to survive; the SDK keeps retrying and applies the flags once they land.
 *
 * Registered as `onlyWhenBackgrounded`, so the same expiry on a live foreground tab — where the
 * user really is sitting on default flag values — still reaches Error Tracking.
 *
 * Matches the init wait specifically rather than the SDK's timeout-error name, so a timeout on any
 * other LaunchDarkly operation stays reported.
 */
const LAUNCH_DARKLY_INIT_TIMEOUT_ERROR_MESSAGE = 'waitForInitialization timed out'

export const isLaunchDarklyInitTimeoutError = ({ message }: IsLaunchDarklyInitTimeoutErrorParams): boolean =>
  message.includes(LAUNCH_DARKLY_INIT_TIMEOUT_ERROR_MESSAGE)
